module.exports = __webpack_public_path__ + "static/media/admin-dashboard-profile.2383e3fb.svg";